/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeConsequences.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Consequence Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 12:43:41 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const CONSEQUENCE_LIST_CONTAINER_LOADED = 'CONSEQUENCE_LIST_CONTAINER_LOADED';
export const CONSEQUENCE_LIST_CONTAINER_UNLOADED = 'CONSEQUENCE_LIST_CONTAINER_UNLOADED';
export const CONSEQUENCE_LIST_TABLE_LOADED = 'CONSEQUENCE_LIST_TABLE_LOADED';
export const CONSEQUENCE_LIST_TABLE_UNLOADED = 'CONSEQUENCE_LIST_TABLE_UNLOADED';

export const CONSEQUENCE_SELECT_ROW = 'CONSEQUENCE_SELECT_ROW';

export const CONSEQUENCE_ADD = 'CONSEQUENCE_ADD';
export const CONSEQUENCE_EDIT = 'CONSEQUENCE_EDIT';
export const CONSEQUENCE_DELETE = 'CONSEQUENCE_DELETE';
export const CONSEQUENCE_OPEN_WARNING = 'CONSEQUENCE_OPEN_WARNING';
export const CONSEQUENCE_CLOSE_WARNING = 'CONSEQUENCE_CLOSE_WARNING';

export const CONSEQUENCE_EDIT_CONTAINER_LOADED = 'CONSEQUENCE_EDIT_CONTAINER_LOADED';
export const CONSEQUENCE_EDIT_CONTAINER_UNLOADED = 'CONSEQUENCE_EDIT_CONTAINER_UNLOADED';
export const CONSEQUENCE_EDIT_FORM_LOADED = 'CONSEQUENCE_EDIT_FORM_LOADED';
export const CONSEQUENCE_EDIT_FORM_UNLOADED = 'CONSEQUENCE_EDIT_FORM_UNLOADED';

export const CONSEQUENCE_EDIT_DATA_LOAD = 'CONSEQUENCE_EDIT_DATA_LOAD';

export const CONSEQUENCE_EDIT_CONTAINER_SUBMIT = 'CONSEQUENCE_EDIT_CONTAINER_SUBMIT';
export const CONSEQUENCE_EDIT_CONTAINER_CANCEL = 'CONSEQUENCE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeConsequences.js